module.exports = __webpack_public_path__ + "static/media/email-already-confirmed.c91d1b1b.svg";